import {CompareColumnInfo, FilterRule, TableFilter, TableHeaderFilterMenuData} from '../../stores/GeneralSelectorTableStore';
import {observer} from 'mobx-react';
import React from 'react';
import {observable} from 'mobx';
import {CompareMode} from '../../stores/CompareStore';
import {classes, stylesheet} from 'typestyle';
import {px} from 'csx';
import MinMaxFilter from './MinMaxFilter';
import _ from 'lodash';
import {KPI} from '../../kpi';
import {GreenColorFaded20} from '../../styles/colors';

interface MinMaxFilterMenuProps {
    tableHeaderFilterMenu: TableHeaderFilterMenuData;
    activeTableFilters: TableFilter[];
    applyFilterRules: (filterRules: FilterRule[], kpi: KPI, compareColumnInfo?: CompareColumnInfo) => void;
    triggerTableHeaderFilterMenu: () => void;
    isRate: boolean;
    channelCompareIsEnabled: boolean;
}

@observer
export default class MinMaxFilterMenu extends React.Component<MinMaxFilterMenuProps> {
    @observable private minValue = '';
    @observable private maxValue = '';

    constructor(props: MinMaxFilterMenuProps) {
        super(props);
        this.applyOutsiteFilterRules(props);
    }

    private applyOutsiteFilterRules(props: MinMaxFilterMenuProps) {
        const filterRules = this.getFilterRulesForAttribute(props);
        const minRule = filterRules.find((rule) => rule.operator === '>=');
        const maxRule = filterRules.find((rule) => rule.operator === '<=');
        const applyRate = (value: number) => (props.isRate ? _.round(value * 100, 2) : value);
        this.minValue = minRule ? applyRate(_.round(minRule.value, 4)).toString() : '';
        this.maxValue = maxRule ? applyRate(_.round(maxRule.value, 4)).toString() : '';
    }

    public componentWillReceiveProps(props: MinMaxFilterMenuProps): void {
        this.applyOutsiteFilterRules(props);
    }

    private getFilterRulesForAttribute(props: MinMaxFilterMenuProps): FilterRule[] {
        const {tableHeaderFilterMenu, activeTableFilters, channelCompareIsEnabled} = props;
        const {attribute, isClosed} = tableHeaderFilterMenu;
        if (!isClosed) {
            const activeFilter = activeTableFilters.filter((filter) => {
                if (filter.compareColumnInfo) {
                    const compareColumnInfo = tableHeaderFilterMenu.compareColumnInfo;
                    if (!compareColumnInfo) {
                        return false;
                    }
                    switch (filter.compareColumnInfo.compareMode) {
                        case CompareMode.AbsDiffMode:
                        case CompareMode.RatioMode:
                            return filter.attribute === attribute && filter.compareColumnInfo.compareMode === compareColumnInfo.compareMode;
                        case CompareMode.ChannelOrVariantColumn:
                            return (
                                compareColumnInfo.targetName &&
                                filter.compareColumnInfo.targetName &&
                                filter.attribute === attribute &&
                                filter.compareColumnInfo.targetName === compareColumnInfo.targetName
                            );
                        default:
                            break;
                    }
                }

                if (channelCompareIsEnabled) {
                    return false;
                }

                return filter.attribute === attribute;
            });
            if (activeFilter.length > 0) {
                return activeFilter.map((singleTableFilter) => {
                    return {
                        value: singleTableFilter.rules.value,
                        operator: singleTableFilter.rules.operator,
                    };
                });
            }
        }
        return [];
    }

    public applyNewFilterRules = (): void => {
        const {attribute, compareColumnInfo} = this.props.tableHeaderFilterMenu;
        const cleanValue = (value: string) => value.replace(/,/g, '.').replace(/ /g, '');
        const applyRate = (value: number) => (this.props.isRate ? value / 100 : value);

        const cleanMinValue = applyRate(_.round(parseFloat(cleanValue(this.minValue)), 2));
        const cleanMaxValue = applyRate(_.round(parseFloat(cleanValue(this.maxValue)), 2));
        const filterRules: FilterRule[] = [];

        if (!isNaN(cleanMinValue)) {
            filterRules.push({
                operator: '>=',
                value: cleanMinValue,
            });
        }

        if (!isNaN(cleanMaxValue)) {
            filterRules.push({
                operator: '<=',
                value: cleanMaxValue,
            });
        }

        this.props.applyFilterRules(filterRules, attribute, compareColumnInfo);
        this.props.triggerTableHeaderFilterMenu();
    };

    public render() {
        return (
            <div style={{textAlign: 'center'}}>
                <MinMaxFilter
                    updateMinValue={(value: string) => (this.minValue = value)}
                    updateMaxValue={(value: string) => (this.maxValue = value)}
                    values={{
                        min: this.minValue,
                        max: this.maxValue,
                    }}
                />
                <div
                    id="applyFilter"
                    className={classes(menuCss.applyAdditionalFilterRules, menuCss.filterBlockButton)}
                    onClick={this.applyNewFilterRules}>
                    <i className="fa fa-check" />
                </div>
            </div>
        );
    }
}

const menuCss = stylesheet({
    applyAdditionalFilterRules: {
        width: '100%',
        height: 30,
        display: 'inline-block',
        borderRadius: 1,
        textAlign: 'center',
        lineHeight: px(30),
        background: GreenColorFaded20,
    },
    filterBlockButton: {
        width: '100% !important',
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/MinMaxFilterMenu.tsx